import { render, staticRenderFns } from "./Base400Gray.vue?vue&type=template&id=fd3749c8&scoped=true&"
var script = {}
import style0 from "./Base400Gray.vue?vue&type=style&index=0&id=fd3749c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3749c8",
  null
  
)

export default component.exports